import React, { useState } from "react";
import { Input } from "../components/Input";
import { Link } from "react-router-dom";
import { doc, setDoc } from "firebase/firestore";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { db, auth } from "../config/firebase";
import { ErrorMessage } from "../components/ErrorMessage";
import { errorHandel } from "../helpersFunction/errorMess";
import { useNavigate } from "react-router-dom";
import { ButtonSubmit } from "../components/ButtonSubmit";

export const Signup = () => {
  const [userData, setUserData] = useState({});
  const [isAgree, setIsAgree] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      const form = e.target;
      const formData = new FormData(form);
      const formJson = Object.fromEntries(formData.entries());
      setUserData(formJson);

      const createdUser = await createUserWithEmailAndPassword(
        auth,
        userData.email,
        userData.password
      );

      await setDoc(doc(db, "users", createdUser.user.uid), {
        fullname: userData.fullname,
        email: userData.email,
      });

      navigate("/books");

      console.log("User Sign Up successfully!");
    } catch (error) {
      setErrorMessage(errorHandel(error.code));
      console.error("Error Sign Up:", error.code);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setErrorMessage("");
  };

  return (
    <div className="my-16 mx-auto flex flex-col w-[360px] min-h-550 p-7 shadow-lg rounded-lg border border-solid border-gray-200">
      <h3 className="text-3xl font-semibold text-green-600 text-center py-5 mb-5">
        SIGN UP
      </h3>
      <form onSubmit={handleSubmit} className="flex flex-col">
        <Input
          fildName="fullname"
          placeholder="Full name"
          type="text"
          handleChange={handleChange}
        />

        <Input
          fildName="email"
          placeholder="Email address"
          type="email"
          handleChange={handleChange}
        />

        <Input
          fildName="password"
          placeholder="Password"
          type="password"
          handleChange={handleChange}
        />

        <label className="flex mb-8 items-center">
          <input
            type="checkbox"
            checked={isAgree}
            onChange={(e) => setIsAgree(e.target.checked)}
            className="form-checkbox h-5 w-5"
          />
          <span className="ml-2 text-gray-400 text-xs">
            I accept the Terms of Use & Privacy Policy
          </span>
        </label>

        <ErrorMessage errorMessage={errorMessage} />

        <ButtonSubmit
          disabled={!userData.email || !userData.password || !isAgree}
          text="SIGN UP"
        />
      </form>

      <p className="text-gray-600 text-sm">
        Already have an account?
        <Link
          to="/signin"
          className="text-green-600 ml-2 font-semibold text-base"
        >
          SIGN IN
        </Link>
      </p>
    </div>
  );
};
